const H5_ORIGIN = 'https://h5.heymetaplayer.com'
const H5_USER_LOGIN_PATH = '/#/pages/userCenter/agency/login'
const H5_USER_REGISTER_PATH = '/#/pages/userCenter/agency/register'
const H5_USER_FORGOT_PASSWORD_PATH = '/#/pages/userCenter/agency/forgotPassword'

function getViewportWidth () {
  if (typeof window === 'undefined') return Number.POSITIVE_INFINITY

  const widths = [
    window.innerWidth,
    window.document && window.document.documentElement
      ? window.document.documentElement.clientWidth
      : 0,
    window.screen ? window.screen.width : 0
  ].filter(width => Number(width) > 0)

  return widths.length > 0 ? Math.min(...widths) : Number.POSITIVE_INFINITY
}

/**
 * 判断当前浏览器是否为手机或平板设备。
 * 同时兼容真实 Android/iOS、iPadOS，以及 Chrome 开发者工具的手机模拟模式。
 */
export function isMobileBrowser () {
  if (typeof navigator === 'undefined') return false

  const userAgentDataMobile = Boolean(
    navigator.userAgentData && navigator.userAgentData.mobile === true
  )
  const userAgent = navigator.userAgent || ''
  const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|HarmonyOS|HUAWEI|HONOR/i.test(userAgent)
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const touchCapable = navigator.maxTouchPoints > 0 || (
    typeof window !== 'undefined' && 'ontouchstart' in window
  )
  const coarsePointer = typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches
  const viewportWidth = getViewportWidth()
  const emulatedMobileViewport = viewportWidth <= 768 && (
    touchCapable || coarsePointer || viewportWidth <= 640
  )

  return userAgentDataMobile || mobileUserAgent || isIPadOS || emulatedMobileViewport
}

function isLocalDevelopmentHost () {
  if (typeof window === 'undefined') return false

  const hostname = (window.location.hostname || '').toLowerCase()
  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.local') ||
    /^10\./.test(hostname) ||
    /^192\.168\./.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(hostname)
}

function getH5UserCenterTarget () {
  if (typeof window === 'undefined') {
    return `${H5_ORIGIN}${H5_USER_LOGIN_PATH}`
  }

  const pathname = (window.location.pathname || '').toLowerCase()
  const query = window.location.search || ''

  // PC 注册页切换到 H5 注册页，并保留 invite_code 等参数。
  if (pathname.includes('/sign/sign-up')) {
    return `${H5_ORIGIN}${H5_USER_REGISTER_PATH}${query}`
  }

  // PC 找回密码页切换到 H5 找回密码页。
  if (pathname.includes('/sign/find-pass')) {
    return `${H5_ORIGIN}${H5_USER_FORGOT_PASSWORD_PATH}${query}`
  }

  return `${H5_ORIGIN}${H5_USER_LOGIN_PATH}`
}

/**
 * PC 用户中心在手机浏览器打开时，切换到 H5 用户中心。
 * 仅按访问域名排除本地调试，不再依赖 NODE_ENV，避免测试构建部署后失效。
 */
export function redirectMobilePcUserCenterToH5 () {
  if (
    typeof window !== 'undefined' &&
    !isLocalDevelopmentHost() &&
    isMobileBrowser()
  ) {
    window.location.replace(getH5UserCenterTarget())
    return true
  }

  return false
}
